import { RefObject, useEffect } from 'react'

export function useKeypressListener<T extends readonly string[]>(
    keys: T,
    callback: (key: T[number]) => void,
    targets: (RefObject<HTMLElement> | HTMLElement)[],
    excludeTargets: RefObject<HTMLElement>[] = []
) {
    useEffect(() => {
        const controller = new AbortController()

        window.addEventListener(
            'keydown',
            (e) => {
                if (
                    !targets.some((t) => {
                        if (t instanceof HTMLElement) {
                            return t.contains(e.target as Node | null)
                        }
                        return t.current?.contains(e.target as Node | null)
                    })
                ) {
                    return
                }

                if (
                    excludeTargets.some(
                        (t) => t.current && t.current.contains(e.target as Node | null)
                    )
                ) {
                    return
                }

                if (keys.includes(e.key)) {
                    callback(e.key)
                }
            },
            { signal: controller.signal }
        )

        return () => controller.abort()
    }, [keys, callback])
}
